module.exports = __webpack_public_path__ + "static/10-04ca183c67d026cae3cfc21f62b5a4e2.png";